import React from 'react';
import styles from './VideoModal.styl';
import WhiteX from '-!svg-react-loader!../../assets/X_Wrong_White.svg';
/* eslint import/no-webpack-loader-syntax: off */

const VideoModal = props => {

  return (
    <div className={styles.background}>
      <div className={styles.innerModal}>
        <div className={styles.closeModal} onClick={props.closeModal}>
          <WhiteX width={30} height={30} />
        </div>
        <iframe width="560" height="315" src={props.url} frameBorder="0" allowFullScreen title={props.url} className={styles.iframe}></iframe>
      </div>
    </div>
  );
};


export default VideoModal;



// WEBPACK FOOTER //
// ./src/components/modal/VideoModal.js